'use strict'
const API = require('../../APIs/configApi')
const formatterAPI = require('../../APIs/formatter')

const verifyAuthentication = function (responseData, context) {
  if (responseData.code === 401) {
    context.commit('SET_SESSION_EXP_MAIN_APP', true)
  }
}

export default {
  async readClusterListMiddleware(context) {
    const responseData = await API.getAllCluster(context);
    if (responseData.success) { //If correct writes the data in memory
      context.commit('SET_CLUSTER_DATA_MIDDLEWARE', formatterAPI.default.formatClusters(responseData.data))
      return true
    } else {
      verifyAuthentication(responseData, context)
      return false
    }
  },
  async readClusterDataMiddleware({commit, state}, payload) {
    if(state.clusterDataMiddleware !== null && typeof(state.clusterDataMiddleware.clusterProjectListCache[payload.clusterId])!== 'undefined'){
      // Using the cached value
      commit('SET_PROJECTS_CLUST_MIDDLEWARE', state.clusterDataMiddleware.clusterProjectListCache[payload.clusterId]);
      return {success: true, data: state.clusterDataMiddleware.clusterProjectListCache[payload.clusterId]};
    }
    const responseData = await API.getProjectsClust(payload);
    if (responseData.success) { //If correct writes the data in memory
      commit('SET_PROJECTS_CLUST_MIDDLEWARE', formatterAPI.default.formatProjects(responseData.data))
      return responseData
    }
		else{
			commit('SET_PROJECTS_CLUST_MIDDLEWARE', null)
      return responseData
		}
  },
  async readReportsProjMiddleware({commit, state}, payload) {
    try {
      let responseData = await API.getReportsProj(payload);
      if (!responseData.success) { //If not success it could be that we have reports sharing
        //It could be that the reports were shared individually (here should also come the project individually)
        if (state.clusterDataMiddleware !== null && typeof (state.clusterDataMiddleware.sharedReports) !== 'undefined') {
          const reportsShared = state.clusterDataMiddleware.sharedReports.filter(report => report.projectId === payload.projectId)
          if (reportsShared.length > 0) {
            responseData.data.projectName = reportsShared[0].projectData.projectName
            responseData.data.projectId = reportsShared[0].projectData.projectId
            responseData.data.clusterId = reportsShared[0].projectData.clusterId
            responseData.data.accesstype = false
            responseData.data.reports = reportsShared
            responseData.success = true
          }
        }
      }
      if (responseData.success) { //If correct writes the data in memory
        commit('SET_REPORTS_PROJ_MIDDLEWARE', {
          reportsProj: responseData.data
        })
        commit('SET_CURRENT_NAME_PROJECT_NAVIGATION', responseData.data.projectName)
        commit('SET_ALLOW_EDIT_PROY_NAVIGATION', responseData.data.accesstype)
        return responseData
      } else {
        commit('SET_REPORTS_PROJ_MIDDLEWARE', {
          reportsProj: null
        })
        commit('SET_CURRENT_NAME_PROJECT_NAVIGATION', `Project(${payload.projectId})`)
        commit('SET_ALLOW_EDIT_PROY_NAVIGATION', false)

        return responseData
      }
    } catch {
      commit('SET_REPORTS_PROJ_MIDDLEWARE', {
        reportsProj: null
      })
      return false
    }
  },
  async readSingleReportMiddleware(context, payload) {
    const responseData = await API.getSingleReport(payload);
    if (responseData.success) { //If correct writes the data in memory
      return responseData.data
    }
    context.commit('SET_REPORT_ACCESS_TYPE_MIDDLEWARE', {responseData})
    verifyAuthentication(responseData, context)
    return null
  },
  async downloadRawFilesMiddleware(context, payload) {
    let responseData = await API.downloadRawFiles(payload);
    return responseData.correct || responseData.success
  },
  async saveRawFileMiddleware(context, payload) {
    let responseData = await API.saveRawFile(payload);
    return responseData.success
  },
  async extractBinaryMiddleware(context, payload) {
    let responseData = await API.extractBinary(payload);
    if (responseData.success) {
      context.commit('SET_EXTRACTED_DATA_BINARY_MIDDLEWARE', responseData.data)
    } else {
      context.commit('SET_EXTRACTED_DATA_BINARY_MIDDLEWARE', null)
    }
    return responseData.success
  },
  async drawCircuitMiddleware(context, payload) {
    let responseData = await API.drawCircuit(payload);
    if (responseData.success) {
      context.commit('SET_DRAW_CIRCUIT_MIDDLEWARE', responseData.data.data)
    } else {
      context.commit('SET_DRAW_CIRCUIT_MIDDLEWARE', null)
    }
    return responseData.success
  },
  async apiRecommendCircuitMiddleware(context, payload) {
    let responseData = await API.recommendCircuit(payload);
    if (responseData.success) {
      context.commit('SET_RECOMMEND_CIRCUIT_MIDDLEWARE', responseData.data)
    } else {
      context.commit('SET_RECOMMEND_CIRCUIT_MIDDLEWARE', null)
    }
    return responseData.success
  },
  async updateReportMiddleware(context, payload) {
    let responseData = await API.updateReport(payload);
    if (!responseData.success) {
      verifyAuthentication(responseData, context)
    }
    return responseData.success
  },
  async removeReportMiddleware(context, payload) {
    let responseData = await API.removeReport(payload);
    return responseData.success
  },
  async addClusterMiddleware(context, payload) {
    const responseData = await API.addCluster(payload);
    return responseData
  },
  async addProjectMiddleware(context, payload) {
    const responseData = await API.addProject(payload);
    return responseData
  },
  async editProjectMiddleware(context, payload) {
    const responseData = await API.editProject(payload);
    return responseData
  },
  async editClusterMiddleware(context, payload) {
    const responseData = await API.editCluster(payload);
    return responseData
  },
  async addReportMiddleware(context, payload) {
    const responseData = await API.addReport(payload);
    if (responseData.success && typeof (responseData.data) !== 'undefined') {
      context.commit('SET_CURRENT_ReportViewer', responseData.data)
      return {success: true, id: responseData.data.id }
    }
    return responseData
  },
  async addHyperlinkReportMiddleware(context, payload) {
    const responseData = await API.addHyperlinkReport(payload);
    if (responseData.success && typeof (responseData.data) !== 'undefined') {
      return {success: true, id: responseData.data.id }
    }
    return responseData
  },
  async addComparisonReportMiddleware(context, payload) {
    const responseData = await API.addComparisonReport(payload);
    if (responseData.success && typeof (responseData.data) !== 'undefined') {
      context.commit('SET_CURRENT_ReportViewer', responseData.data)
      return responseData.data.id
    }
    return null
  },
  async readUsersSharingMiddleware(context, payload) {
    const responseData = await API.readUsersSharing(payload);
    if (responseData.success) { //If correct writes the data in memory
      context.commit('SET_USERS_SHARING_MIDDLEWARE', {
        usersSharing: responseData.data
      })
      return true
    }
    return false
  },
  async addTemplateMiddlware(context, payload) {
    const responseData = await API.addTemplate(payload);
    if (responseData.success) {
      context.commit('SET_NEW_TEMPLATE_DB_MIDDLEWARE', responseData.data)
    } else {
      context.commit('SET_NEW_TEMPLATE_DB_MIDDLEWARE', null)
    }
    return responseData.success
  },
  async requestSingleTemplateMiddlware(context, payload) {
    const responseData = await API.getSingleTemplate(payload);
    if (responseData.success) { //If correct writes the data in memory
      context.commit('SET_TEMPLATE_DB_MIDDLEWARE', responseData.data.template)
      return true
    }
    verifyAuthentication(responseData, context)
    return false
  },
  async requestTemplateListMiddleware(context, payload) {
    const responseData = await API.requestTemplateList(payload);
    if (responseData.success) { //If correct writes the data in memory
      context.commit('SET_TEMPLATES_LIST_MIDDLEWARE', responseData.data.templates)
      context.commit('SET_PROJ_TEMPLATES_LIST_MIDDLEWARE', payload.projectId)
      return true
    } else {
      context.commit('SET_TEMPLATES_LIST_MIDDLEWARE', responseData.data.templates)
      context.commit('SET_PROJ_TEMPLATES_LIST_MIDDLEWARE', payload.projectId)
      return false
    }
  },
  async updateTemplateMiddlware(context, payload) {
    const responseData = await API.updateTemplate(payload);
    return responseData.success
  },
  async removeTemplatesMiddlware(context, payload) {
    const responseData = await API.removeTemplate(payload);
    return responseData.success
  },
  async requestMultipleTemplatesFileMiddlware(context, payload) {
    const success = await API.requestMultipleTemplatesFile(payload);
    return success
  },
  async shareClusterMiddleware(context, payload) {
    const response = await API.shareCluster(payload);
    return response
  },
  async updateShareClusterMiddleware(context, payload) {
    const response = await API.updateShareCluster(payload);
    return response
  },
  async deleteShareClusterMiddleware(context, payload) {
    const response = await API.deleteShareCluster(payload);
    return response
  },
  async shareReportMiddleware(context, payload) {
    const response = await API.shareReport(payload);
    return response
  },
  async updateShareReportMiddleware(context, payload) {
    const response = await API.updateShareReport(payload);
    return response
  },
  async deleteShareReportMiddleware(context, payload) {
    const response = await API.deleteShareReport(payload);
    return response
  },
  setReportsProjMiddleware({ commit }, newArray) {
    commit('SET_REPORTS_PROJ_MIDDLEWARE', { reportsProj: newArray })
  },
	async sendResourceAccessRequestMiddleware(context, payload){
		const response = await API.sendResourceAccessRequest(payload);
		return response;
	},
	async readClusterOwnerDataMiddleware(context, payload){
		const response = await API.getClusterOwnerData(payload)
		return response.data;

	},
	async fetchResourceAccessRequestsMiddleware(context, payload){
		const response = await API.fetchResourceAccessRequests(payload);
		context.commit('SET_FETCH_ACCESS_REQUESTSS_MIDDLEWARE', response.data)
		context.commit('SET_TOTAL_PENDING_RESOURCE_REQUESTSS_MIDDLEWARE', response.pendingRequests)
		return response;
	},
	async approveResourceAccessRequestMiddleware(context, payload){
		const response = await API.approveResourceAccessRequest(payload);
		return response.success;
	},
	async rejectResourceAccessRequestMiddleware(context, payload){
		const response = await API.rejectResourceAccessRequest(payload);
		return response.success;
	},
	async deleteResourceAccessRequestMiddleware(context, payload){
		const response = await API.deleteResourceAccessRequest(payload);
		return response;
	},
	async manageClusterArchivalMiddleware(context, payload) {
    const responseData = await API.manageClusterArchival(payload);
    return responseData
  },
	async manageClusterFavouriteMiddleware(context, payload) {
    const responseData = await API.manageClusterFavourite(payload);
    return responseData
  },
	async optOutSharedClusterMiddleware(context, payload) {
    const responseData = await API.optOutSharedCluster(payload);
    return responseData
  },
	async fetchSharedClusterEmailsByUser(context, payload) {
    const responseData = await API.sharedClusterEmailsByUser(payload);
    return responseData
  }
}
